import { ThumbnailPreview } from '../ThumbnailPreview';
import { ThumbnailPreviewConfig } from '../ThumbnailPreviewConfiguration';
import { ThumbnailPreviewMetadata } from '@quickplay/player-interface';

const DEFAULT_COLS_GRID = 10; //default number of columns
const DEFAULT_ROWS_GRID = 10; //default number of rows
const THUMBNAIL_DURATION = 6; // default keyframe duration

export class ThumbnailPreviewImpl implements ThumbnailPreview {
  private endpointUrl_: string;
  private config_: ThumbnailPreviewConfig;

  constructor(endpointUrl: string, config: ThumbnailPreviewConfig = {}) {
    this.endpointUrl_ = endpointUrl;
    this.config_ = config;
  }

  // returns the left position of the thumbnail in the spriteUrl.
  private getThumbnailRowIndex = (
    seekPoint: number,
    keyframeDuration: number,
    numColumns: number,
    numRows: number,
  ): number => {
    const scalefactor: number = Math.floor(seekPoint / keyframeDuration / numColumns / numRows);
    const spriteDuration: number = keyframeDuration * numRows * numColumns;
    const thumbnailId: number = Math.floor((seekPoint - scalefactor * spriteDuration) / keyframeDuration);
    return -Math.floor(thumbnailId % numColumns);
  };

  // returns the top position of the thumbnail in the spriteUrl.
  private getThumbnailColumnIndex = (
    seekPoint: number,
    keyframeDuration: number,
    numColumns: number,
    numRows: number,
  ): number => {
    const scalefactor: number = Math.floor(seekPoint / keyframeDuration / numColumns / numRows);
    const spriteDuration: number = keyframeDuration * numRows * numColumns;
    const thumbnailId: number = Math.floor((seekPoint - scalefactor * spriteDuration) / keyframeDuration);
    return -Math.floor(thumbnailId / numColumns);
  };

  // returns the spriteUrl based on the position.
  private getSpriteUrl = (seekPoint: number, keyframeDuration: number, numRows: number, numColumns: number): string => {
    const spriteIndex: string = '' + (Math.floor(seekPoint / (keyframeDuration * numRows * numColumns)) + 1);
    return this.endpointUrl_.replace('~index~', spriteIndex);
  };

  // return thumbnail metadata for the corresponding positions.
  getThumbnail = (position: number): ThumbnailPreviewMetadata => {
    const numRows: number = this.config_.numRows || DEFAULT_ROWS_GRID;
    const numColumns: number = this.config_.numColumns || DEFAULT_COLS_GRID;
    const keyframeDuration: number = this.config_.keyframeDuration || THUMBNAIL_DURATION;
    const thumbnailRowIndex: number = this.getThumbnailRowIndex(position, keyframeDuration, numColumns, numRows);
    const thumbnailColumnIndex: number = this.getThumbnailColumnIndex(position, keyframeDuration, numColumns, numRows);
    const spriteUrl: string = this.getSpriteUrl(position, keyframeDuration, numRows, numColumns);

    //thumbnail metadata.
    return {
      thumbnailRowIndex: thumbnailRowIndex,
      thumbnailColumnIndex: thumbnailColumnIndex,
      urls: [spriteUrl],
      totalRows: numRows,
      totalColumns: numColumns,
      isSprite: true,
    };
  };
}
